import { MarketplaceOrdersListResponse } from '@/modules/marketplace/orders/services/apiValidation/marketplaceListOrdersApiValidation.ts'
import { MarketplaceOrderDetail } from '@/modules/marketplace/orders/services/apiValidation/marketplaceOrderDetailApiValidation.ts'
import { MarketplaceListResponse } from '@/modules/marketplace/marketplaces/services/apiValidationSchemas.ts'
import { Marketplace } from '@/modules/marketplace/marketplaces/types/Marketplace.ts'
import { MarketplaceProductListResponse } from '@/modules/marketplace/products/services/apiValidationSchemas.ts'
import {
  MarketplaceCategory,
  MarketplaceProductDetail
} from '@/modules/marketplace/products/types/MarketplaceProduct.ts'
import { InventoryMovementHistoryListResponse } from '@/modules/marketplace/inventory/services/apiValidationSchemas.ts'
import { InventoryMovementHistoryItem } from '@/modules/marketplace/inventory/types/Inventory.ts'
import { DiscountListResponse } from '@/modules/marketplace/discounts/services/apiValidationSchemas.ts'

export const marketplaceOrdersPage1: MarketplaceOrdersListResponse = {
  results: [
    {
      orderId: 1,
      clientName: 'Juan Pérez',
      orderType: 'DELIVERY',
      status: 'CREATED',
      itemsCount: 2,
      total: 29.5,
      createdAt: '25/06/2026 14:15',
      branchOfficeName: 'Sucursal Centro'
    },
    {
      orderId: 2,
      clientName: 'María López',
      orderType: 'DELIVERY',
      status: 'PREPARING',
      itemsCount: 3,
      total: 47.0,
      createdAt: '25/06/2026 13:30',
      branchOfficeName: 'Sucursal Norte'
    },
    {
      orderId: 3,
      clientName: 'Carlos Rodríguez',
      orderType: 'PICKUP',
      status: 'READY',
      itemsCount: 1,
      total: 15.0,
      createdAt: '25/06/2026 12:45',
      branchOfficeName: 'Sucursal Sur'
    },
    {
      orderId: 4,
      clientName: 'Ana Martínez',
      orderType: 'DELIVERY',
      status: 'DELIVERING',
      itemsCount: 4,
      total: 62.0,
      createdAt: '25/06/2026 11:00',
      branchOfficeName: 'Sucursal Centro'
    },
    {
      orderId: 5,
      clientName: 'Luis García',
      orderType: 'DELIVERY',
      status: 'DELIVERED',
      itemsCount: 2,
      total: 33.0,
      createdAt: '25/06/2026 10:20',
      branchOfficeName: 'Sucursal Este'
    },
    {
      orderId: 6,
      clientName: 'Sofía Torres',
      orderType: 'PICKUP',
      status: 'CANCELED',
      itemsCount: 1,
      total: 8.5,
      createdAt: '25/06/2026 09:05',
      branchOfficeName: 'Sucursal Norte'
    }
  ],
  pagination: {
    count: 6,
    start: 1,
    limit: 20,
    end: 6,
    next: false,
    prev: false,
    pages: 1,
    range: [1],
    total: 6
  },
  status: true,
  total: undefined
}

const buildOrderDetail = (
  overrides: Partial<MarketplaceOrderDetail> & { orderId: number }
): MarketplaceOrderDetail => ({
  branchOfficeId: 5,
  clientId: 42,
  orderType: 'DELIVERY',
  status: 'CREATED',
  total: 0,
  deliveryAddress: null,
  deliveryTime: null,
  paymentMethod: null,
  installments: null,
  notesForAlly: null,
  clientName: 'Cliente',
  branchOfficeName: 'Sucursal Centro',
  createAt: '2026-06-25T14:15:00Z',
  createBy: 42,
  updateAt: null,
  updateBy: null,
  items: [],
  statusHistories: [],
  subOrders: [],
  ...overrides
})

export const marketplaceOrderDetailById: Record<
  number,
  MarketplaceOrderDetail
> = {
  1: buildOrderDetail({
    orderId: 1,
    clientName: 'Juan Pérez',
    branchOfficeName: 'Sucursal Centro',
    orderType: 'DELIVERY',
    status: 'CREATED',
    total: 29.5,
    deliveryAddress: 'Av. Principal, Caracas',
    deliveryTime: 30,
    paymentMethod: 'CASH',
    items: [
      {
        orderItemId: 10001,
        productId: 100,
        productSku: 'BURG-001',
        productDescription: 'Hamburguesa Doble Queso',
        quantity: 2,
        price: 12.5,
        subtotal: 25
      },
      {
        orderItemId: 10002,
        productId: 101,
        productSku: 'FRIES-001',
        productDescription: 'Papas Fritas Medianas',
        quantity: 1,
        price: 4.5,
        subtotal: 4.5
      }
    ],
    statusHistories: [
      {
        statusHistoryId: 1,
        status: 'CREATED',
        comment: null,
        createAt: '2026-06-25T14:15:00Z',
        createBy: 42
      }
    ]
  }),
  2: buildOrderDetail({
    orderId: 2,
    clientName: 'María López',
    branchOfficeName: 'Sucursal Norte',
    orderType: 'DELIVERY',
    status: 'PREPARING',
    total: 41,
    deliveryAddress: 'Calle 5, Sucursal Norte',
    deliveryTime: 25,
    paymentMethod: 'INSTALLMENTS',
    installments: 3,
    items: [
      {
        orderItemId: 10003,
        productId: 102,
        productSku: 'CHKN-001',
        productDescription: 'Pollo Frito (4 piezas)',
        quantity: 1,
        price: 18,
        subtotal: 18
      },
      {
        orderItemId: 10004,
        productId: 103,
        productSku: 'SALD-001',
        productDescription: 'Ensalada César',
        quantity: 2,
        price: 9,
        subtotal: 18
      },
      {
        orderItemId: 10005,
        productId: 104,
        productSku: 'SODA-001',
        productDescription: 'Refresco Grande',
        quantity: 1,
        price: 5,
        subtotal: 5
      }
    ],
    statusHistories: [
      {
        statusHistoryId: 2,
        status: 'CREATED',
        comment: null,
        createAt: '2026-06-25T13:30:00Z',
        createBy: 42
      },
      {
        statusHistoryId: 3,
        status: 'PREPARING',
        comment: 'Pago confirmado',
        createAt: '2026-06-25T13:35:00Z',
        createBy: 10
      }
    ]
  }),
  3: buildOrderDetail({
    orderId: 3,
    clientName: 'Carlos Rodríguez',
    branchOfficeName: 'Sucursal Sur',
    orderType: 'PICKUP',
    status: 'READY',
    total: 15,
    paymentMethod: 'CASH',
    items: [
      {
        orderItemId: 10006,
        productId: 105,
        productSku: 'PIZZ-001',
        productDescription: 'Pizza Margarita Personal',
        quantity: 1,
        price: 15,
        subtotal: 15
      }
    ],
    statusHistories: []
  }),
  4: buildOrderDetail({
    orderId: 4,
    clientName: 'Ana Martínez',
    branchOfficeName: 'Sucursal Centro',
    orderType: 'DELIVERY',
    status: 'DELIVERING',
    total: 62,
    deliveryAddress: 'Av. Bolívar, Caracas',
    deliveryTime: 40,
    paymentMethod: 'CASH',
    items: [
      {
        orderItemId: 10007,
        productId: 106,
        productSku: 'WRAP-001',
        productDescription: 'Wrap de Pollo',
        quantity: 2,
        price: 11,
        subtotal: 22
      },
      {
        orderItemId: 10008,
        productId: 107,
        productSku: 'SOUP-001',
        productDescription: 'Sopa del Día',
        quantity: 1,
        price: 7.5,
        subtotal: 7.5
      },
      {
        orderItemId: 10009,
        productId: 108,
        productSku: 'JUCE-001',
        productDescription: 'Jugo Natural',
        quantity: 2,
        price: 4.5,
        subtotal: 9
      },
      {
        orderItemId: 10010,
        productId: 109,
        productSku: 'DESS-001',
        productDescription: 'Postre del Chef',
        quantity: 1,
        price: 6,
        subtotal: 6
      }
    ],
    statusHistories: []
  }),
  5: buildOrderDetail({
    orderId: 5,
    clientName: 'Luis García',
    branchOfficeName: 'Sucursal Este',
    orderType: 'DELIVERY',
    status: 'DELIVERED',
    total: 33,
    deliveryAddress: 'Calle Este 10',
    deliveryTime: 20,
    paymentMethod: 'CASH',
    items: [
      {
        orderItemId: 10011,
        productId: 110,
        productSku: 'PAST-001',
        productDescription: 'Pasta Boloñesa',
        quantity: 1,
        price: 13,
        subtotal: 13
      },
      {
        orderItemId: 10012,
        productId: 111,
        productSku: 'BRED-001',
        productDescription: 'Pan de Ajo',
        quantity: 2,
        price: 3.5,
        subtotal: 7
      }
    ],
    statusHistories: []
  }),
  6: buildOrderDetail({
    orderId: 6,
    clientName: 'Sofía Torres',
    branchOfficeName: 'Sucursal Norte',
    orderType: 'PICKUP',
    status: 'CANCELED',
    total: 8.5,
    paymentMethod: 'CASH',
    items: [
      {
        orderItemId: 10013,
        productId: 112,
        productSku: 'DESS-002',
        productDescription: 'Brownie con Helado',
        quantity: 1,
        price: 8.5,
        subtotal: 8.5
      }
    ],
    statusHistories: [
      {
        statusHistoryId: 4,
        status: 'CANCELED',
        comment: 'Cliente solicita cancelación',
        createAt: '2026-06-25T09:10:00Z',
        createBy: 42
      }
    ]
  })
}

const marketplaceRows: Marketplace[] = [
  {
    marketplaceId: 1,
    commercialAllyId: 3,
    name: 'Tienda Oficial Aliado 1',
    description: 'Marketplace principal del aliado comercial.',
    type: 'Private',
    isActive: true,
    createAt: '2025-09-04T12:00:00Z',
    updateAt: null
  },
  {
    marketplaceId: 2,
    commercialAllyId: 4,
    name: 'Outlet Aliado 2',
    description: 'Liquidaciones y productos con descuento.',
    type: 'Public',
    isActive: true,
    createAt: '2025-09-10T09:30:00Z',
    updateAt: '2025-10-01T15:45:00Z'
  },
  {
    marketplaceId: 3,
    commercialAllyId: 2,
    name: 'Mayorista Aliado 3',
    description: null,
    type: 'Private',
    isActive: false,
    createAt: '2025-08-21T18:05:00Z',
    updateAt: null
  },
  {
    marketplaceId: 4,
    commercialAllyId: 5,
    name: 'Marketplace Retail Aliado 4',
    description: 'Catálogo de retail para clientes finales.',
    type: 'Public',
    isActive: true,
    createAt: '2025-07-15T08:00:00Z',
    updateAt: '2025-09-28T11:20:00Z'
  },
  {
    marketplaceId: 5,
    commercialAllyId: 1,
    name: 'Tienda Corporativa Aliado 5',
    description: 'Ventas corporativas y contratos B2B.',
    type: 'Private',
    isActive: true,
    createAt: '2025-06-30T14:10:00Z',
    updateAt: null
  },
  {
    marketplaceId: 6,
    commercialAllyId: 3,
    name: 'Pop-up Store Aliado 1',
    description: 'Tienda temporal para campañas de temporada.',
    type: 'Public',
    isActive: false,
    createAt: '2025-05-12T10:45:00Z',
    updateAt: '2025-06-01T09:00:00Z'
  }
]

export const marketplacesPage1: MarketplaceListResponse = {
  results: marketplaceRows,
  pagination: {
    count: marketplaceRows.length,
    start: 1,
    limit: 20,
    end: marketplaceRows.length,
    next: false,
    prev: false,
    pages: 1,
    range: [1],
    total: marketplaceRows.length
  },
  status: true,
  total: undefined
}

export const marketplaceDetailById: Record<number, Marketplace> =
  marketplaceRows.reduce(
    (acc, row) => {
      acc[row.marketplaceId] = {
        ...row,
        updateAt: row.updateAt ?? '2026-01-15T10:00:00Z'
      }
      return acc
    },
    {} as Record<number, Marketplace>
  )

export const marketplaceMutationResponse: Marketplace = {
  marketplaceId: 10,
  commercialAllyId: 1,
  name: 'Mi Marketplace',
  description: 'Tienda oficial',
  type: 'Private',
  isActive: true,
  createAt: '2026-02-01T12:00:00Z',
  updateAt: null
}

export const marketplaceDeleteResponse = { deleted: true }

type MockVariant = MarketplaceProductDetail['variants'][number]
type MockProductBase = Omit<
  MarketplaceProductDetail,
  | 'minPrice'
  | 'maxPrice'
  | 'totalStock'
  | 'variantCount'
  | 'variantSkus'
  | 'variantAttributeValues'
  | 'variants'
>

const buildVariant = (
  productVariantId: number,
  sku: string,
  name: string,
  attributes: Record<string, string>,
  price: number,
  stock: number
): MockVariant => ({
  productVariantId,
  sku,
  name,
  attributesJson: JSON.stringify(attributes),
  price,
  stock,
  imageUrl: null,
  isActive: true
})

const buildProduct = (
  base: MockProductBase,
  variants: MockVariant[]
): MarketplaceProductDetail => {
  const prices = variants.map((variant) => variant.price)
  return {
    ...base,
    minPrice: Math.min(...prices),
    maxPrice: Math.max(...prices),
    totalStock: variants.reduce((total, variant) => total + variant.stock, 0),
    variantCount: variants.length,
    variantSkus: variants.map((variant) => variant.sku),
    variantAttributeValues: variants.flatMap((variant) =>
      Object.values(JSON.parse(variant.attributesJson ?? '{}'))
    ) as string[],
    variants
  }
}

const marketplaceProducts: MarketplaceProductDetail[] = [
  buildProduct(
    {
      productId: 1,
      marketplaceId: 10,
      marketplaceName: 'Tienda Oficial Aliado 1',
      commercialAllyId: 3,
      branchOfficeId: 5,
      modelId: 20,
      categoryId: 1,
      description: 'iPhone 15 Pro Max',
      deliveryTime: 3,
      isActive: true,
      createAt: '2025-09-04T12:00:00Z',
      updateAt: null,
      imageUrl: 'https://s3.amazonaws.com/bucket/phone.jpg',
      brandName: 'Apple',
      brand: 'Apple',
      modelName: 'iPhone 15 Pro Max',
      isSponsored: true,
      sponsorPriority: 1,
      allyAverageRating: 4.5
    },
    [
      buildVariant(
        1,
        'PHONE-001-256',
        '256GB',
        { Capacidad: '256GB' },
        1299.99,
        25
      ),
      buildVariant(
        2,
        'PHONE-001-512',
        '512GB',
        { Capacidad: '512GB' },
        1499.99,
        10
      )
    ]
  ),
  buildProduct(
    {
      productId: 2,
      marketplaceId: 10,
      marketplaceName: 'Tienda Oficial Aliado 1',
      commercialAllyId: 3,
      branchOfficeId: 5,
      modelId: 21,
      categoryId: 2,
      description: 'Funda de silicona MagSafe',
      deliveryTime: 2,
      isActive: true,
      createAt: '2025-09-05T09:30:00Z',
      updateAt: null,
      imageUrl: null,
      brandName: 'Apple',
      brand: 'Apple',
      modelName: 'iPhone 15',
      isSponsored: false,
      sponsorPriority: 0,
      allyAverageRating: 4.5
    },
    [
      buildVariant(3, 'CASE-014-BLU', 'Azul', { Color: 'Azul' }, 39.9, 70),
      buildVariant(4, 'CASE-014-BLK', 'Negro', { Color: 'Negro' }, 39.9, 50)
    ]
  ),
  buildProduct(
    {
      productId: 3,
      marketplaceId: 11,
      marketplaceName: 'Outlet Aliado 2',
      commercialAllyId: 4,
      branchOfficeId: 6,
      modelId: 22,
      categoryId: 3,
      description: 'MacBook Air M3 13"',
      deliveryTime: 5,
      isActive: true,
      createAt: '2025-09-06T14:10:00Z',
      updateAt: '2025-09-08T10:00:00Z',
      imageUrl: 'https://s3.amazonaws.com/bucket/macbook.jpg',
      brandName: 'Apple',
      brand: 'Apple',
      modelName: 'MacBook Air M3',
      isSponsored: true,
      sponsorPriority: 2,
      allyAverageRating: 4.2
    },
    [buildVariant(5, 'LAP-2201', 'Estándar', {}, 1499, 8)]
  ),
  buildProduct(
    {
      productId: 4,
      marketplaceId: 11,
      marketplaceName: 'Outlet Aliado 2',
      commercialAllyId: 4,
      branchOfficeId: 6,
      modelId: 23,
      categoryId: 1,
      description: 'Samsung Galaxy S24 Ultra',
      deliveryTime: 4,
      isActive: false,
      createAt: '2025-09-07T08:00:00Z',
      updateAt: null,
      imageUrl: null,
      brandName: 'Samsung',
      brand: 'Samsung',
      modelName: 'Galaxy S24 Ultra',
      isSponsored: false,
      sponsorPriority: 0,
      allyAverageRating: 3.9
    },
    [buildVariant(6, 'PHONE-044', '512GB', { Capacidad: '512GB' }, 1199.5, 0)]
  ),
  buildProduct(
    {
      productId: 5,
      marketplaceId: 12,
      marketplaceName: 'Mayorista Aliado 3',
      commercialAllyId: 2,
      branchOfficeId: 7,
      modelId: 24,
      categoryId: 2,
      description: 'Cargador USB-C 30W',
      deliveryTime: 1,
      isActive: true,
      createAt: '2025-09-08T16:45:00Z',
      updateAt: null,
      imageUrl: null,
      brandName: 'Anker',
      brand: 'Anker',
      modelName: 'PowerPort III',
      isSponsored: false,
      sponsorPriority: 0,
      allyAverageRating: 4.7
    },
    [buildVariant(7, 'ACC-0090', 'Estándar', {}, 24.99, 300)]
  ),
  buildProduct(
    {
      productId: 6,
      marketplaceId: 12,
      marketplaceName: 'Mayorista Aliado 3',
      commercialAllyId: 2,
      branchOfficeId: 7,
      modelId: 25,
      categoryId: 3,
      description: 'iPad Air 11"',
      deliveryTime: 3,
      isActive: true,
      createAt: '2025-09-09T11:20:00Z',
      updateAt: null,
      imageUrl: null,
      brandName: 'Apple',
      brand: 'Apple',
      modelName: 'iPad Air',
      isSponsored: true,
      sponsorPriority: 3,
      allyAverageRating: 4.4
    },
    [
      buildVariant(8, 'TAB-0033-128', '128GB', { Capacidad: '128GB' }, 699, 15),
      buildVariant(9, 'TAB-0033-256', '256GB', { Capacidad: '256GB' }, 799, 6)
    ]
  )
]

export const marketplaceProductsPage1: MarketplaceProductListResponse = {
  results: marketplaceProducts,
  pagination: {
    count: marketplaceProducts.length,
    start: 0,
    limit: 20,
    end: marketplaceProducts.length,
    next: false,
    prev: false,
    pages: 1,
    range: [1],
    total: marketplaceProducts.length
  },
  status: true,
  total: undefined
}

export const marketplaceProductDetailById: Record<
  number,
  MarketplaceProductDetail
> = marketplaceProducts.reduce(
  (acc, product) => {
    acc[product.productId] = product
    return acc
  },
  {} as Record<number, MarketplaceProductDetail>
)

export const marketplaceProductMutationResponse = marketplaceProducts[0]

export const marketplaceProductDeleteResponse = { deleted: true }

export const marketplaceCategoriesResponse: MarketplaceCategory[] = [
  { categoryId: 1, name: 'Smartphones', description: 'Teléfonos celulares' },
  { categoryId: 2, name: 'Accesorios', description: 'Fundas, cargadores' },
  { categoryId: 3, name: 'Laptops', description: 'Computadoras portátiles' }
]

// Catalogs come from the gestion API, which wraps the list in `data`
export const marketplaceProductBranchOfficesCatalog = {
  message: 'OK',
  data: [
    { id: '5', label: 'Sucursal Centro' },
    { id: '6', label: 'Sucursal Norte' },
    { id: '7', label: 'Sucursal Sur' }
  ]
}

const productModels = [
  { id: '20', label: 'iPhone 15 Pro Max', maxCost: '1500', brandId: '100' },
  { id: '21', label: 'iPhone 15', maxCost: '1100', brandId: '100' },
  { id: '22', label: 'MacBook Air M3', maxCost: '1700', brandId: '100' },
  { id: '23', label: 'Galaxy S24 Ultra', maxCost: '1300', brandId: '101' },
  { id: '24', label: 'PowerPort III', maxCost: '40', brandId: '102' },
  { id: '25', label: 'iPad Air', maxCost: '800', brandId: '100' }
]

const toModelOption = ({
  id,
  label,
  maxCost
}: (typeof productModels)[number]) => ({
  id,
  label,
  maxCost
})

export const marketplaceProductModelsCatalog = {
  message: 'OK',
  data: productModels.map(toModelOption)
}

export const marketplaceProductBrandIds = ['100', '101', '102']

export const marketplaceProductModelsCatalogByBrand = (brandId: string) => ({
  message: 'OK',
  data: productModels
    .filter((model) => model.brandId === brandId)
    .map(toModelOption)
})

const inventoryMovementsByVariant: Record<
  number,
  InventoryMovementHistoryItem[]
> = {
  1: [
    {
      movementId: 501,
      productId: 1,
      variantId: 1,
      type: 'INBOUND',
      quantityChange: 10,
      stockBefore: 15,
      stockAfter: 25,
      reason: 'Recepción de mercancía',
      reference: 'PO-2025-001',
      createdBy: 42,
      createAt: '2025-09-04T12:00:00Z'
    },
    {
      movementId: 502,
      productId: 1,
      variantId: 1,
      type: 'OUTBOUND',
      quantityChange: -3,
      stockBefore: 28,
      stockAfter: 25,
      reason: 'Venta en tienda',
      reference: null,
      createdBy: 42,
      createAt: '2025-09-10T09:15:00Z'
    }
  ],
  3: [
    {
      movementId: 511,
      productId: 2,
      variantId: 3,
      type: 'ADJUSTMENT',
      quantityChange: 5,
      stockBefore: 115,
      stockAfter: 120,
      reason: 'Ajuste de inventario físico',
      reference: null,
      createdBy: 7,
      createAt: '2025-09-06T10:00:00Z'
    }
  ],
  5: [
    {
      movementId: 521,
      productId: 3,
      variantId: 5,
      type: 'RETURN',
      quantityChange: 1,
      stockBefore: 7,
      stockAfter: 8,
      reason: 'Devolución de cliente',
      reference: 'ORD-3321',
      createdBy: 15,
      createAt: '2025-09-08T13:40:00Z'
    }
  ],
  6: [
    {
      movementId: 531,
      productId: 4,
      variantId: 6,
      type: 'OUTBOUND',
      quantityChange: -2,
      stockBefore: 2,
      stockAfter: 0,
      reason: 'Venta en tienda',
      reference: null,
      createdBy: 42,
      createAt: '2025-09-09T16:20:00Z'
    }
  ],
  7: [
    {
      movementId: 541,
      productId: 5,
      variantId: 7,
      type: 'INBOUND',
      quantityChange: 100,
      stockBefore: 200,
      stockAfter: 300,
      reason: 'Recepción de mercancía',
      reference: 'PO-2025-014',
      createdBy: 42,
      createAt: '2025-09-11T08:00:00Z'
    }
  ],
  8: [
    {
      movementId: 551,
      productId: 6,
      variantId: 8,
      type: 'ADJUSTMENT',
      quantityChange: -1,
      stockBefore: 16,
      stockAfter: 15,
      reason: 'Ajuste de inventario físico',
      reference: null,
      createdBy: 7,
      createAt: '2025-09-12T11:30:00Z'
    }
  ],
  103: [
    {
      movementId: 561,
      productId: 103,
      variantId: 103,
      type: 'OUTBOUND',
      quantityChange: -5,
      stockBefore: 7,
      stockAfter: 2,
      reason: 'Venta en tienda',
      reference: null,
      createdBy: 42,
      createAt: '2025-09-13T09:00:00Z'
    }
  ]
}

export const inventoryMovementsPageByVariant: Record<
  number,
  InventoryMovementHistoryListResponse
> = Object.entries(inventoryMovementsByVariant).reduce(
  (acc, [variantId, movements]) => {
    acc[Number(variantId)] = {
      results: movements,
      pagination: {
        count: movements.length,
        start: 0,
        limit: 20,
        end: movements.length,
        next: false,
        prev: false,
        pages: 1,
        range: [1],
        total: movements.length
      },
      status: true,
      total: undefined
    }
    return acc
  },
  {} as Record<number, InventoryMovementHistoryListResponse>
)

export const inventoryAdjustResponse = {
  movementId: 501,
  productId: 100,
  variantId: 1,
  quantityChange: 10,
  stockBefore: 25,
  stockAfter: 35,
  reason: 'Recepción de mercancía',
  createAt: '2025-09-04T12:00:00Z'
}

export const inventoryBulkUpdateResponse = { success: true }

export const inventorySummaryResponse = {
  totalProducts: 150,
  activeProducts: 120,
  totalStock: 3500,
  lowStockCount: 15,
  outOfStockCount: 5,
  averagePrice: 599.99
}

export const inventoryLowStockResponse = {
  items: [
    {
      productId: 103,
      marketplaceId: 10,
      commercialAllyId: 1,
      description: 'Funda iPhone 15',
      minPrice: 29.99,
      maxPrice: 29.99,
      totalStock: 2,
      categoryId: 2,
      variants: [
        {
          variantId: 103,
          sku: 'CASE-001',
          name: 'Estándar',
          stock: 2,
          price: 29.99
        }
      ]
    },
    {
      productId: 4,
      marketplaceId: 11,
      commercialAllyId: 4,
      description: 'Samsung Galaxy S24 Ultra',
      minPrice: 1199.5,
      maxPrice: 1199.5,
      totalStock: 0,
      categoryId: 1,
      variants: [
        {
          variantId: 6,
          sku: 'PHONE-044',
          name: '512GB',
          stock: 0,
          price: 1199.5
        }
      ]
    }
  ],
  totalCount: 2,
  threshold: 5
}

const toProductInventory = (product: MarketplaceProductDetail) => ({
  productId: product.productId,
  description: product.description,
  minPrice: product.minPrice,
  maxPrice: product.maxPrice,
  totalStock: product.totalStock,
  isActive: product.isActive,
  branchOfficeId: product.branchOfficeId,
  categoryId: product.categoryId,
  variants: product.variants.map((variant) => ({
    variantId: variant.productVariantId,
    sku: variant.sku,
    name: variant.name,
    price: variant.price,
    stock: variant.stock,
    imageUrl: variant.imageUrl,
    isActive: variant.isActive
  }))
})

export const inventoryProductById: Record<
  number,
  ReturnType<typeof toProductInventory>
> = {
  ...Object.fromEntries(
    marketplaceProducts.map((product) => [
      product.productId,
      toProductInventory(product)
    ])
  ),
  103: {
    productId: 103,
    description: 'Funda iPhone 15',
    minPrice: 29.99,
    maxPrice: 29.99,
    totalStock: 2,
    isActive: true,
    branchOfficeId: 5,
    categoryId: 2,
    variants: [
      {
        variantId: 103,
        sku: 'CASE-001',
        name: 'Estándar',
        price: 29.99,
        stock: 2,
        imageUrl: null,
        isActive: true
      }
    ]
  }
}

export const discountsList: DiscountListResponse = {
  totalCount: 3,
  results: [
    {
      discountId: 1,
      name: 'Descuento de lanzamiento',
      discountType: 'PERCENTAGE',
      discountValue: 15,
      isComposable: false,
      priority: 1,
      productVariantId: 1,
      startsAt: '2026-10-01T00:00:00Z',
      endsAt: '2026-12-31T23:59:00Z',
      isActive: true
    },
    {
      discountId: 2,
      name: 'Rebaja fija',
      discountType: 'FIXED_AMOUNT',
      discountValue: 2.5,
      isComposable: true,
      priority: 2,
      productVariantId: 2,
      startsAt: null,
      endsAt: null,
      isActive: true
    },
    {
      discountId: 3,
      name: 'Promoción vencida',
      discountType: 'PERCENTAGE',
      discountValue: 30,
      isComposable: false,
      priority: 3,
      productVariantId: 3,
      startsAt: '2026-01-01T00:00:00Z',
      endsAt: '2026-02-01T00:00:00Z',
      isActive: false
    }
  ]
}

export const discountMutationResponse = discountsList.results[0]

export const discountDeleteResponse = { deleted: true }
